@if (iconOnly()) {
  <button
    mat-icon-button
    class="icon-sm opacity-50"
    [disabled]="isDisabled$ | async"
    (click)="downloadReport()"
  >
    <mat-icon>download</mat-icon>
  </button>
} @else {
  <button
    mat-stroked-button
    [disabled]="isDisabled$ | async"
    (click)="downloadReport()"
  >
    @if (withIcon()) {
      <mat-icon>download</mat-icon>
    }
    Download Report
  </button>
}
